// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rgcVsbJ9XRybjcr87CBz{display:flex;gap:8px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/compliance/pages/localNumbers/ui/UseCaseModalTabs/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,OAAA","sourcesContent":[".images {\n  display: flex;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"images": `rgcVsbJ9XRybjcr87CBz`
};
export default ___CSS_LOADER_EXPORT___;
